module.exports = __webpack_public_path__ + "img/c4.ff9c838f.svg";